module.exports = __webpack_public_path__ + "static/media/bg19.099010a9.jpg";